module.exports = __webpack_public_path__ + "static/shop-deploy-49c47e7a6b611a46502b76a5f3a74076.jpg";